export const springFormPan = {
  recipes: [
    {
      id: 'Apple Torte',
      link: 'https://pamperedchef.widen.net/view/thumbnail/f36i7nde7p/post-recipe-apple-torte-steps.jpg?position=c&color=ffffffff&quality=80&t.format=jpeg&x.share=t',
      img: {
        src: 'https://pamperedchef.widen.net/content/f36i7nde7p/jpeg/post-recipe-apple-torte-steps.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80',
        alt: 'post-recipe-apple-torte-steps.jpg',
      },
    },
  ],
};
